import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {environment} from '../../../environments/environment';
import { Prize } from './prize.model';

@Injectable({
  providedIn: 'root'
})
export class PrizesService {

  constructor(
    private http: HttpClient
  ) { }

  getAllPrizes(): Observable<any> {
    return this.http.get(environment.apiUrl + '/prize/getAll');
  }

  getOnePrize(prizeId: string | number): Observable<any> {
    return this.http.get(environment.apiUrl + '/prize/getSingle/' + prizeId );
  }

  addPrize(prize: Prize): Observable<any> {
    return this.http.post(environment.apiUrl + '/prize/new/', prize);
  }

  editPrize(prize: Prize, prizeId: number): Observable<any> {
    return this.http.put(environment.apiUrl + '/prize/edit/', {...prize, prizeId: prizeId});
  }

  deletePrize(prizeId: number): Observable<any> {
    return this.http.delete(environment.apiUrl + '/prize/delete/' + prizeId);
  }
}
